import 'dayjs/locale/pt-br';

import dayjs, { Dayjs } from 'dayjs';
import localeData from 'dayjs/plugin/localeData';
import relativeTime from 'dayjs/plugin/relativeTime';

dayjs.locale('pt-BR');
dayjs.extend(localeData);
dayjs.extend(relativeTime);

class DateHelper {
  static isDateExpired(date: string): boolean {
    const now = dayjs();
    const inputDate = dayjs(date);

    return inputDate.isBefore(now);
  }

  static startMonth(date: Date): Dayjs {
    return dayjs(date).startOf('month');
  }

  static endMonth(date: Date): Dayjs {
    return dayjs(date).endOf('month');
  }

  static toDayjs(date: Date | string): Dayjs {
    if (typeof date === 'string') {
      return dayjs(date, 'YYYY-MM-DD');
    }

    return dayjs(date);
  }

  static toISO(date: Dayjs | Date): string {
    return dayjs(date).toISOString();
  }

  static diffDays(startDate: Date, endDate: Date): number {
    return dayjs(endDate).endOf('day').diff(dayjs(startDate).startOf('day'), 'days')
  }
}

export default DateHelper;
